import { create } from 'zustand'
import { ModelAnswerFromProps } from '../../components/stores/models/StoreDetailModel'

interface StepsDistributorStore {
    steps: ModelAnswerFromProps[]
    setSteps: (item: ModelAnswerFromProps) => void
    clearSteps: () => void
}

export const useStepsDistributor = create<StepsDistributorStore>((set, get) => ({
    steps: [],
    setSteps: (item) => {
        const stepsSaved = get().steps
        const index = stepsSaved.findIndex((step) => step._id == item._id)
        if (index !== -1) {
            set({ steps: stepsSaved.map((step, i) => (i === index ? item : step)) })
        } else {
            set({ steps: [...stepsSaved, item] })
        }
    },
    clearSteps: () => {
        set({ steps: [] })
    },
}))
